import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  selectAuthStatus,
  selectIsAuthenticated,
} from "store/src/slices/auth-slice";
import Loader from "../loader";

export default function PrivateRoute({ children }) {
  const authStatus = useSelector(selectAuthStatus);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  if (authStatus === "loading") {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
